// FOOTBALL FIXTURES VIEW
import updateText from './update-text';
import updateSynopsis from './update-synopsis';
import updateBetting from './update-betting';

export default function(data) {
  // set status
  this.setAttribute('data-status', data.status);

  // set home score
  updateText(this.querySelector('[data-update="score-home"]'), data.teams.home.score);

  // set away score
  updateText(this.querySelector('[data-update="score-away"]'), data.teams.away.score);

  // set aggregate
  if (data.teams.home.hasOwnProperty('aggregate')) {
    updateText(
      this.querySelector('[data-update="score-aggregate"]'),
      [data.teams.home.aggregate, '-', data.teams.away.aggregate].join('')
    );
  }

  // set summary
  updateText(this.querySelector('[data-update="status-note"]'), data.summary ? data.summary.full : null);

  // update synopsis
  updateSynopsis(this.querySelector('[data-update="synopsis-home"]'), data.teams.home);
  updateSynopsis(this.querySelector('[data-update="synopsis-away"]'), data.teams.away);

  // set betting
  updateBetting(this.querySelector('[data-role="betting"]'), data.betting);
}
